import { type SettingResponse } from '@/settings/api/models/settingResponse';
import { useHttpClient } from '@/common/api/httpClient';
import { storeToRefs } from 'pinia';
import { useLanguageStore } from 'shared/translations/stores/languageStore';

export interface ReadSettingsResponse {
  ok: true;
  setting: SettingResponse;
}

export function useReadSettings() {
  const httpClient = useHttpClient();
  const languageStore = useLanguageStore();
  const { translations } = storeToRefs(languageStore);

  return {
    execute,
  };

  async function execute() {
    const headers = httpClient.defaultHeaders();
    const request = new Request(httpClient.siteUrl('setting'), {
      headers,
    });

    const text = translations.value.settings.actions.read;

    const response = await httpClient.action<ReadSettingsResponse>(request, {
      title: text.title,
      errorTitle: text.error,
      async processOk(response) {
        const json = (await response.json()) as SettingResponse;
        return {
          ok: true,
          setting: json,
        };
      },
    });

    return response;
  }
}
